import { Interval } from "../classes/Interval";
import { calculateForce, getForceCalculationModeForWorkoutType } from "./ForceCalculation";

// Mock Algorithm object - you'll need to import the real one
const Algorithm = {
  generateIntervals: (data: any, userWeight: number) => {
    // Mock implementation
    return [];
  },
  generateIntervalsParams: (data: any, userWeight: number, structuredIntervals?: Array<Interval>) => {
    // Mock implementation
    return [];
  },
  setActivityStructure: (intervals: Array<Interval>) => {
    // Mock implementation
    return {
      total_strain: 0,
      avg_strain: 0,
      avg_interval_duration: 0,
      max_strength: 0
    };
  }
};

export let _weightDataArray: [number, number][] = [[0, 0]];
export var _beginningTime: any;
export var date: number | null = null;

const startTimer = () => {
  date = Date.now();
};

export const resetTimer =() =>{
  date = null;
};

export const timeSinceBeginning = () => {
  if (date === null || date === undefined || isNaN(date)) {
    return 0;
  }
  const timeElapsed = (Date.now() - date) / 1000;
  // console.log('sensorDataAnalysis: Time elapsed:', timeElapsed, 'seconds');
  return timeElapsed;
};

export const addDataToString = (data: number | string): void => {
  if (data === null) return;

  // Ensure timer is started if it hasn't been started yet
  if (date === null || date === undefined || isNaN(date)) {
    startTimer();
  }

  // Handle string values ('MAX', 'Out') and convert to numeric values
  let processedData: number;
  if (typeof data === 'string') {
    if (data === 'MAX' || data === 'Out') {
      processedData = 0;
    } else {
      processedData = parseFloat(data) || 0;
    }
  } else {
    processedData = data < 0 ? 0 : data;
  }

  _weightDataArray.push([processedData, timeSinceBeginning()]);
};

export const dataArrayDifferential =() =>{
  const intervThreshold = 3; // [kg]
  if((_weightDataArray[_weightDataArray.length-2]?.[0] != 0) && 
  ((_weightDataArray[_weightDataArray.length-2]?.[0] < intervThreshold) &&
  (_weightDataArray[_weightDataArray.length-1]?.[0] >= intervThreshold))){
    return 1;
  }else if((_weightDataArray[_weightDataArray.length-2]?.[0] > intervThreshold) && 
  (_weightDataArray[_weightDataArray.length-1]?.[0] <= intervThreshold)){
    return -1;
  }
  return 0;
}

export const freeDataArray = () => {
  _weightDataArray = [[0,0]];
};

export const arrayToCSV = (data: any) => {
  var csv = "";
  data.forEach(function(row: any) {
          csv += row.join(",");
          csv += "\n";
  });

  return csv;
};

export const getResultsFromData = (data: any, userWeight: number, activityType: String, structuredIntervals?: Array<Interval>) => {
  const intervals = activityType == 'raw' ? Algorithm.generateIntervals(data, userWeight): 
    Algorithm.generateIntervalsParams(data, userWeight, structuredIntervals);
  const activity = Algorithm.setActivityStructure(intervals);

  let result = {
    "n_intervals": intervals.length ? intervals.length : 1,
    "interval_count": intervals.length ? intervals.length : 1,
    "intervals":  intervals,
    "total_strain": activity.total_strain ? activity.total_strain : -1,
    "avg_strain": activity.avg_strain ? activity.avg_strain : -1,
    "avg_interval_duration": activity.avg_interval_duration ? activity.avg_interval_duration : -1,
    "duration_variation": 0,
    "max_strength":  activity.max_strength ? activity.max_strength : -1, // maxStrength(_weightDataArray),
    "strengthVariation": 0
};
  return result;
};

export async function onEnd (userWeight: any, activityType: any,addedWeight:number, intervals?: Array<Interval>) {
  let now = new Date().toISOString();
  
  // Convert data array to CSV format
  const csvData = arrayToCSV(_weightDataArray);
  
  // Create a zip file with the CSV data
  const JSZip = (await import('jszip')).default;
  const zip = new JSZip();
  zip.file('data.csv', csvData);
  
  // Generate the zip file as base64
  const zipBase64 = await zip.generateAsync({ type: 'base64' });
  
  const archive = ({
      "type": activityType.selectedWorkout ? activityType.selectedWorkout : "raw", 
      "subtype": activityType.type ? activityType.type : "none",
      "date": now ? now : "unknown time", 
      "title": activityType.title ? activityType.title : "Free hanging", 
      "tag": `${activityType.notes}`,
      "data": zipBase64, // Send base64 encoded zip file as backend expects
      "userWeight": userWeight ? userWeight : 150, 
      //"result": results,
      "addedWeight": addedWeight,
      "notes": `${activityType.notes}`,
      "intervals": intervals || []
  });
  if (archive.intervals && archive.intervals.length > 0) {
    if (archive.intervals[0].end !== undefined) {
      if (archive.intervals[0].end >= _weightDataArray.length) {
        console.warn('⚠️ sensorDataAnalysis: Interval end index exceeds data array length!');
      }
    }
  }
  // Don't clear the data array here - it's needed for the return value
  // freeDataArray();
  return archive;
};

export const onStart = () => {
  startTimer();
  _weightDataArray = [];
};

export const pulledWeight = (setup: any, userWeight: number, forcePlateData: number, addedWeight: number) => {
  var weight;
  switch (setup) {
    case "hangboard":
      if (userWeight + addedWeight - forcePlateData < 0.15) 
        return 0;
       else if (forcePlateData < 0.01)
        return "Out"; // out
      else 
        weight = Math.round(10 * (userWeight + addedWeight - forcePlateData)) / 10;
      return weight.toFixed(1);
    case "portable":
      weight = Math.round(10 * forcePlateData) / 10;
      return weight.toFixed(1);

    case "lift":
      if (forcePlateData < 0.15) {
        return "Out"; // out
      } else if (forcePlateData - userWeight - addedWeight < 0.15) {
        return 0;
      } else {
        weight = Math.round(10 * (forcePlateData - userWeight - addedWeight)) / 10;
      }
      return weight.toFixed(1);
    default:
      if (userWeight + addedWeight - forcePlateData < 0.15) {
        return 0;
      } else if (forcePlateData < 0.15) {
        return "Out"; // out
      } else {
        weight = Math.round(10 * (userWeight + addedWeight - forcePlateData)) / 10;
      }
      return weight.toFixed(1);
  }
};